import NavigationAccessLayout from './navigation_access_layout.jsx';

const NavigationAccessPage = () => {
  return (
      <NavigationAccessLayout />
  );
};

export default NavigationAccessPage;